.label {
  margin-left: var(--spacingMd);
  color: var(--paletteBlue2);
}

// TODO: [PROF-6648] remove this after updating textarea
.textarea {
  width: 100%;
  border: 1px solid var(--paletteNeutral0);
  border-radius: 5px;
  padding: 10px;
  color: var(--paletteBlue0);
  background: var(--paletteWhite0);
}

.selectInput {
  width: 100%;
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--spacingMd);
}

.content {
  display: flex;
  flex-direction: column;
  gap: var(--spacingLg);
  padding-top: var(--spacingLg);
}
